module.exports = __webpack_public_path__ + "img/thumbnail_Springbok_f_albino.5b3ecf32.png";